import { ToolUsage } from "./tool-usage.model";

export class ToolUsageGroup {
    public toolName: string;
    public toolDetailsId: number;
    public lineName: string;
    public cleaningPercentage: number;
    public maintenancePercentage: number;
    public measurementsPercentage: number;
    public children: ToolUsage[];

    constructor(toolUsage: any= {}) {
        this.toolName = toolUsage.toolName;
        this.toolDetailsId = toolUsage.toolDetailsId;
        this.lineName = toolUsage.lineName;
        this.cleaningPercentage = toolUsage.cleaningPercentage || 0;
        this.maintenancePercentage = toolUsage.maintenancePercentage || 0;
        this.measurementsPercentage = toolUsage.measurementsPercentage || 0;
    }

    public getBackgroundColor(value: number) {
        if (value < 75) {
            return 'bg-success';
        }
        if (value < 90) {
            return 'bg-warning'
        }
        return 'bg-danger';
    }
}
